import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { ThemeOptions} from '@material-ui/core/styles/createMuiTheme';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

const theme = createMuiTheme({
	palette: {
		primary: { main: '#388e3c', },
		secondary: { main: '#f5f5f5' },
	},
} as ThemeOptions);

ReactDOM.render(
	<Router>
		<MuiThemeProvider theme={theme}>
			<Route path="/" component={App} />
		</MuiThemeProvider>
	</Router>,
  document.getElementById('root') as HTMLElement
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx